
<template>
    <ListDialog ref="PurchaseSummaryDialog" :title="$parent.formatTitle('仕入集計表')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="PurchaseSummaryReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【仕入集計表】のデータを選択でき、初期値は×で消してから変更が可能です。" />
	      <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCounterpart title="仕入先" :editor="editor" :value.sync="counterpart" :needsSupplier="true" tooltip="ここで仕入先を選択をすると、選択した仕入先だけのデータを出力する事ができます。選択しない場合はすべての仕入先のデータが出力できます。" />
        <AtcCategory title="取引先区分" :categoryGroup="categoryGroupCounterpart" :value.sync="counterpartCategory" tooltip="ここで取引先区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
        <AtcCommodity title="商品" :editor="editor" :value.sync="commodity" tooltip="ここで商品を選択をすると、選択した商品だけのデータを出力する事ができます。選択しない場合はすべての商品のデータが出力できます。" />
        <AtcCategory title="商品区分" :categoryGroup="categoryGroupCommodity" :value.sync="commodityCategory" tooltip="ここで商品区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
        <ComboBox title="出力ソート" :editor="editor" :value.sync="sort" list="purchaseSummarySortTypes" :showDefault="false" :required="true" tooltip="明細区分は選択した明細区分・集計区分1・2の順番､仕入ランキングは仕入金額の降順で帳票に出力することができます。" />
        <AutoComplete title="明細区分" :editor="editor" :value.sync="itemCategory" list="purchaseSummaryCategoryTypes" :required="true" tooltip="データの明細区分を選択できます。区分は【マスタ設定】の【区分一覧】から設定ができます。初期値は×で消してから変更が可能です。" />
        <AutoComplete title="集計区分1" :editor="editor" :value.sync="summaryCategory1" list="purchaseSummaryCategoryTypes" :required="summaryCategory2 != null" tooltip="データの集計区分を選択でき、選択することで分析する区分を追加して集計することができます。区分は【マスタ設定】の【区分一覧】から設定ができます。" />
        <AutoComplete title="集計区分2" :editor="editor" :value.sync="summaryCategory2" list="purchaseSummaryCategoryTypes" tooltip="データの集計区分を選択でき、選択することで分析する区分を追加して集計することができます。区分は【マスタ設定】の【区分一覧】から設定ができます。" />
        <Calendar title="期間(From)" :editor="editor" :value.sync="startDate" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="startDateFlag" tooltip="データを帳票に出力をする期間の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	      <Calendar title="期間(To)" :editor="editor" :value.sync="endDate" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="endDateFlag"  tooltip="データを帳票に出力をする期間の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
        <CheckBox title="集計対象" :editor="editor" :value.sync="includeProspect" list="purchaseIncludeProspect" tooltip="未売上の入荷や発注の仕入見込を集計対象に含めることができます。仕入見込の日付は入荷予定日で集計し、仕入金額は【商品マスタ】の【仕入金額】を元に算出します。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>                    
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptPurchaseSummary extends Vue {

  // 仕入集計用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public startDate: Date = null;
  public endDate: Date = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public counterpartCategory: Common.Category = null;
  public categoryGroupCounterpart: Common.CategoryGroup = Common.CategoryGroup.Counterpart;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public sort: number = 0;
  public itemCategory: number = null;
  public summaryCategory1: number = null;
  public summaryCategory2: number = null;
  public includeProspect: boolean = false;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){         
    var query: Common.PurchaseSummaryReportTemplateQuery = new Common.PurchaseSummaryReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    var today = new Date();
    this.startDate = new Date(today.getFullYear(),today.getMonth(),1).getCalendarDate();
    this.endDate = new Date(today.getFullYear(),today.getMonth() +1,0).getCalendarDate();
    (this.$refs.PurchaseSummaryDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.PurchaseSummaryReportQuery = new Common.PurchaseSummaryReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.counterpartCategory = this.counterpartCategory;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.sort = this.sort;
    query.itemCategory = this.itemCategory;
    if (this.summaryCategory1 == null) query.summaryCategory1 = 0;
    else query.summaryCategory1 = this.summaryCategory1;
    if (this.summaryCategory2 == null) query.summaryCategory2 = 0;
    else query.summaryCategory2 = this.summaryCategory2;
    query.includeProspect = this.includeProspect;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
</script>
